<template>
  <div class="mb-2">
    <h3>{{ $dt('RepositoryBackupStats.title', 'Repository Backup Statistics') }}</h3>
    <b-spinner v-if="loading" />
    <div v-if="error" class="text-danger">{{ error }}</div>
    <!-- TODO: make better looking FE -->
    <b-button-group v-if="stats" class="border rounded">
      <b-button :variant="daysSinceLastBackup < -2 ? 'danger' : 'primary'" v-b-tooltip="Date(stats.last_backup_ts)">
        <div><small>Last backup:</small></div>
        {{ lastBackup }}
      </b-button>
      <b-button-group vertical size="sm">
        <b-button variant="light">
          Total repositories:
          {{ stats.repository_count }}
        </b-button>
        <b-button variant="light">
          {{ `Total backup size: ${totalBackupSizeGB.toFixed(2)}GB` }}
        </b-button>
        <b-button variant="light">
          {{ `Last backup: ${backupSizeGB.toFixed(2)}GB` }}
        </b-button>
      </b-button-group>
      <b-button-group vertical size="sm">
        <b-button :variant="successfulBackups ? 'success': 'danger'">
          Success:
          {{ successfulBackups }}
        </b-button>
        <b-button :variant="missingBackups ? 'warning': 'light'">
          Missing:
          {{ missingBackups }}
        </b-button>
        <b-button :variant="failedBackups ? 'danger' : 'light'">
          Failed:
          {{ failedBackups }}
        </b-button>
      </b-button-group>
    </b-button-group>
  </div>
</template>

<script>
import services from '@/services';

export default {
  name: 'RepositoryBackupStats',
  data() {
    return {
      stats: null,
      loading: false,
      error: '',
    };
  },
  computed: {
    daysSinceLastBackup() {
      if (!this.stats) return null;

      const now = new Date().getTime();
      const lastTs = new Date(this.stats.last_backup_ts).getTime();

      const diffInMilliseconds = now - lastTs;
      return Math.floor(diffInMilliseconds / (1000 * 60 * 60 * 24)); // convert milliseconds to days
    },
    lastBackup() {
      if (!this.stats) return 'never';

      return new Intl.RelativeTimeFormat('en', { style: 'long' }).format(-this.daysSinceLastBackup, 'day');
    },
    failedBackups() {
      return this.stats ? this.stats.failed_clone_count + this.stats.failed_backup_count : 0;
    },
    successfulBackups() {
      return this.stats ? this.stats.success_count + this.stats.up_to_date_count : 0;
    },
    missingBackups() {
      return this.stats ? this.stats.missing_count : 0;
    },
    backupSizeGB() {
      return this.stats.last_backup_size ? this.stats.last_backup_size / 1024 : 0;
    },
    totalBackupSizeGB() {
      return this.stats.total_backup_size ? this.stats.total_backup_size / 1024 : 0;
    },
  },
  mounted() {
    this.loadStats();
  },
  methods: {
    loadStats() {
      this.error = '';
      this.loading = true;
      services.dash.backupStatistics().then((response) => {
        this.stats = response.data;
      }).catch((error) => {
        if (error?.status === 404) {
          this.error = 'No backup statistics found';
        } else {
          this.error = 'Error loading backup statistics';
        }
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>
